// get customer payment summary for admin workforce
export const RESET_GET_CUSTOMER_PAYMENT_SUMMARY = "reset_get_customer_payment_summary";
export const GET_CUSTOMER_PAYMENT_SUMMARY = "get_customer_payment_summary";
export const GET_CUSTOMER_PAYMENT_SUMMARY_SUCCESS = "get_customer_payment_summary_success";
export const GET_CUSTOMER_PAYMENT_SUMMARY_FAILURE = "get_customer_payment_summary_failure";
